document.getElementById("cart-icon-clicker").addEventListener("click", function(event){
  event.preventDefault()
});

async function quickAdd(X) {
    const response = await postCart(X);
    console.log(response);
    updateCart(response);
  }
function postCart(X) {
  var formData = {
 'items': [{
  'id': X,
  'quantity': 1
  }]
};
const output = new Promise((resolve, reject) => {
const response = fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
resolve(response)
})
return output
}

function goToCart() {
  document.getElementById("cart-icon-clicker").click();
}
function updateCart(X) {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
  .then((X) => X.text())
  .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
    for (const selector of selectors) {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
      var CDI = document.querySelector("cart-drawer");
      CDI.classList.remove("is-empty");
      var emptyPane = document.getElementsByClassName("drawer__inner-empty");
      for(i = 0; i < emptyPane.length; i++) {
        emptyPane[i].style.display = "none";
      }
      document.getElementById('CartDrawer-Checkout').disabled = false;
      document.getElementById("cart-icon-clicker").click();
    }
  })
}